import React from 'react';
import classnames from 'classnames/bind';
import { string, bool } from 'prop-types';

import styles from './ImagePlaceholder.css';

const cx = classnames.bind(styles);

const ImagePlaceholder = ({ imageUrl, rightSide }) => (
  <div
    className={cx(styles.imagePlaceholder, { 'rightSide': rightSide })}
    style={{ backgroundImage: `url('${imageUrl}')` }}
  />
);

ImagePlaceholder.propTypes = {
  imageUrl: string,
  rightSide: bool
};

ImagePlaceholder.displayName = 'ImagePlaceholder';

export default ImagePlaceholder;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/common/ImgPlaceholder/ImagePlaceholder.js